const brandOfferEntityMapper = ({ brand } = {}) => {
	if (!brand || typeof brand !== "object") return {};

	const {
		incentive_heading: incentiveHeading,
		incentive_code: incentiveCode,
		incentive_subheading: incentiveSubheading,
		incentive_type: incentiveType,
		incentive_remote_id: incentiveRemoteId,
	} = brand;

	return {
		incentiveHeading,
		incentiveCode,
		incentiveSubheading,
		incentiveType,
		incentiveRemoteId,
	};
};

export default brandOfferEntityMapper;
